







import { Component, Vue } from 'vue-property-decorator';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { ConfigsModuleMapper } from '@/store/modules/config';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['jurisdiction']),
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'title']),
  },
});

@Component
export default class LogoComponent extends Mappers {
  get logoLang() {
    let logo = 'en';
    const [
      lang,
    ] = window.location.pathname.split('/').filter((item) => item.length);
    if (this.jurisdiction === 'RUSSIA') {
      logo = 'ru';
    } else if (this.jurisdiction === 'BELARUS' && (lang === 'su' || lang === 'be')) {
      logo = 'ru';
    }
    return logo;
  }
}
